import { Skeleton } from '@app/components/various/Skeleton';

export const CheckoutPoNumberSkeleton = () => {
  return (
    <div className="box">
      <div className="pb-1">
        <Skeleton type="input" size="medium" />
      </div>
    </div>
  );
};
